import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app.routing';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FooterModule } from './shared/footer/footer.module';
import { SidebarModule } from './sidebar/sidebar.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { CarouselComponent } from './carousel/carousel.component';
import { HttpinterceptorsInterceptor } from './interceptors/httpinterceptors.interceptor';
import { VerifyComponent } from './verify/verify.component';
import { ToastrModule } from 'ngx-toastr';
import { JwtinterceptorInterceptor } from './interceptors/jwtinterceptor.interceptor';
import { AuthGuard } from './auth.guard';
import { GoogleauthComponent } from './googleauth/googleauth.component';
import { AttemptHistoryComponent } from './attempt-history/attempt-history.component';
import { DatePipe } from '@angular/common';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { HttploadinginterceptorService } from './interceptors/httploadinginterceptor.service';
import { ExternalComponent } from './external/external.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ToastrModule.forRoot(),
    RouterModule,
    HttpClientModule,
    NavbarModule,
    FooterModule,
    SidebarModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    LandingPageComponent,
    LoginComponent,
    RegisterComponent,
    ForgotpasswordComponent,
    CarouselComponent,
    VerifyComponent,
    GoogleauthComponent,
    AttemptHistoryComponent,
    ResetpasswordComponent,
    LandingPageComponent,
    PaymentHistoryComponent,
    SpinnerComponent,
    ExternalComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: HttpinterceptorsInterceptor, multi:true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtinterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttploadinginterceptorService,
      multi: true,
    },
    AuthGuard,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
